// extracted by mini-css-extract-plugin
export default {"active":"style_active__NXEJ+","normal":"style_normal__rUjSS"};